export const filterResponsesLastEntryPerDateCemex = (objetos) => {
    const users = {};
    objetos.forEach((objeto) => {
        const matricula = objeto.matricula;
        if (!(matricula in users)) {
            users[matricula] = objeto;
        } else {
            const fechaObjeto = new Date(objeto.Fecha_y_hora);
            const fechaUsuario = new Date(users[matricula].Fecha_y_hora);
            if (fechaObjeto > fechaUsuario) {
                users[matricula] = objeto;
            }
        }
    });
    return Object.values(users);
};



export const filterResponsesLastEntryPerDateMerz = (objetos) => {
    const users = {};
    objetos.forEach((objeto) => {
        const matricula = objeto.matricula;
        if (!(matricula in users)) {
            users[matricula] = objeto;
        } else {
            const fechaObjeto = new Date(objeto.Fecha_y_hora);
            const fechaUsuario = new Date(users[matricula].Fecha_y_hora);
            if (fechaObjeto > fechaUsuario) {
                users[matricula] = objeto;
            }
        }
    });
    return Object.values(users);
};